import { baseApi } from "@/shared/api";
import { fileResponseHandler, type FileResponse } from "@/shared/utils";

export const applicationApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      previewApplication: builder.mutation<FileResponse, number>({
        query(id) {
          return {
            url: `/api/hr/amendments/${id}/preview-application/`,
            method: "GET",
            credentials: "include",
            responseHandler: fileResponseHandler,
          };
        },
      }),
    };
  },
});

export const {
  usePreviewApplicationMutation,
} = applicationApi;
